import type { ReactNode } from 'react';

/** The sizes Material UI's `fontSize` prop had: 1em, 1.25rem, 1.5rem. */
export type IconBoxSize = 'inherit' | 'small' | 'medium';

/**
 * Gives an icon element from the icons API (`iconsApi.icon(key)`) the size
 * the deprecated `getIcon(key)` component used to get from its `fontSize`
 * prop, so that moving a caller from one to the other changes no size.
 *
 * Needed because the two kinds of registered icon size differently: a Remix
 * glyph is 24px by width/height attributes, which any CSS rule overrides —
 * BUI's buttons and menu items resize it to their own 1rem or 1.25rem — while
 * a Material UI brand logo is `width: 1em` through its own class.
 * `.waadoo-icon-box > svg` (styles.css, unlayered) sets both to 1em of the
 * box's font size.
 */
export function IconBox(props: { size: IconBoxSize; children: ReactNode }) {
  return (
    <span className="waadoo-icon-box" data-size={props.size}>
      {props.children}
    </span>
  );
}
